import { Team } from '../models';
import { TeamRepository } from '../repositories';

export class GetUserTeamsUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(userId: string): Promise<Team[]> {
    return this.teamRepository.getUserTeams(userId);
  }
}
